module.exports = __webpack_public_path__ + "img/PD1504995004832153600.ad945f66.png";